import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';


@Component({
  selector: 'app-messagebox-dialog',
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './messagebox-dialog.component.html',
  styleUrls: ['./messagebox-dialog.component.scss']
})
export class MessageBoxDialogComponent {

  public mode: string;

  public title = '';

  public html: SafeHtml | null = null;

  public image = null;

  public buttonNoText = '';
  public buttonYesText = '';
  public buttonOkText = '';

  constructor(private translateService: TranslateService,
    public dialogRef: MatDialogRef<MessageBoxDialogComponent>,
    private sanitizer: DomSanitizer) {
    this.mode = 'OK';
    this.buttonNoText = this.translateService.instant('BUTTON_NO');
    this.buttonYesText = this.translateService.instant('BUTTON_YES');
    this.buttonOkText = this.translateService.instant('BUTTON_OK');
  }

  public setImage(img: any) {
    this.image = img;

  }
  public setHtml(html: string, placeHolders?: Array<any>) {
    if (placeHolders) {
      for (let i = 0; i < placeHolders.length; i++) {
        const placeHolder = placeHolders[i];
        const regExp = new RegExp('%' + placeHolder.ph + '%', 'g');
        html = html.replace(regExp, placeHolder.txt);
      }
    }
    const htmlSafe = this.sanitizer.bypassSecurityTrustHtml(html);
    this.html = htmlSafe;
  }

  public setText(mode: string, text: string, placeHolders: Array<any>) {
    this.mode = mode;
    let html = '<span>' + text + '</span>';
    if (placeHolders) {
      for (let i = 0; i < placeHolders.length; i++) {
        const placeHolder = placeHolders[i];
        const regExp = new RegExp('%' + placeHolder.ph + '%', 'g');
        html = html.replace(regExp, placeHolder.txt);
      }
    }
    const htmlSafe = this.sanitizer.bypassSecurityTrustHtml(html);
    this.html = htmlSafe;
  }

  public closeDialog() {
    this.dialogRef.close();
  }

}
